/**
 * A new id of a clip, a custom text or an effect: short, unique inside one document (the server checks at most
 * 64 characters). The time and a random part make two quick ids differ.
 */
export function newDocId(prefix: 'c' | 't' | 'e' = 'c'): string {
  const random = Math.random().toString(36).slice(2, 8);
  return `${prefix}${Date.now().toString(36)}${random}`;
}
